import { createContext, useContext, ReactNode } from "react";
import { useOils, Oil } from "@/hooks/useOils";
import { RelatedItem } from "@/types/oil";

interface OilsContextType {
  oils: Oil[];
  categories: string[];
  loading: boolean;
  error: Error | null;
  searchOils: (query: string) => Oil[];
  getOilById: (id: string) => Oil | undefined;
  refetch: () => Promise<void>;
}

const OilsContext = createContext<OilsContextType | undefined>(undefined);

export function OilsProvider({ children }: { children: ReactNode }) {
  const oilsData = useOils();

  return (
    <OilsContext.Provider value={oilsData}>
      {children}
    </OilsContext.Provider>
  );
}

export function useOilsContext() {
  const context = useContext(OilsContext);
  if (context === undefined) {
    throw new Error("useOilsContext must be used within an OilsProvider");
  }
  return context;
}

// Re-export types for convenience
export type { Oil, RelatedItem };
